import muiRootWrapper from './plugins/custom-mui-theme/wrapRootElement'

export const wrapRootElement = muiRootWrapper
